
import { BUSINESS_UNIT_METADATA } from '../../businessunit/model/business-unit.metadata';
import { FirearmAssignmentType } from '../../firearm_assignment/model/firearm-assignment.types';
import { RANGER_METADATA } from '../../ranger/model/ranger.metadata';
import { ASSETS_USER_DETAILS_METADATA } from '../../userdetails/model/assets-user-details.metadata';
import { EntityMetadata, GenericEntityMetadata, PropertyMetadata, RelationshipType, nullIfContainsNull } from '@scisys-uim/uim-common';


export class FirearmAssignablePersonMetadataBase extends GenericEntityMetadata {
  constructor() {
    super('FirearmAssignablePerson', {
      personId: <PropertyMetadata> {
        name: 'personId',
        type: 'string',
        plural: false,
        isIdentity: true,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 255,
        unique: false
      },
      businessUnit: <PropertyMetadata> {
        name: 'businessUnit',
        type: 'BusinessUnit',
        plural: false,
        isIdentity: false,
        derived: false,
        required: true,
        readOnly: false,
        readable: true,
        writeable: true,
        relationship: true,
        relationshipType: RelationshipType.ManyToOne,
        get relationshipEntityMetadata(): EntityMetadata {
          return BUSINESS_UNIT_METADATA;
        },
        byReference: true,
        unique: false
      },
      ranger: <PropertyMetadata> {
        name: 'ranger',
        type: 'Ranger',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: true,
        readable: true,
        writeable: false,
        relationship: true,
        relationshipType: RelationshipType.ManyToOne,
        get relationshipEntityMetadata(): EntityMetadata {
          return RANGER_METADATA;
        },
        byReference: true,
        unique: false
      },
      user: <PropertyMetadata> {
        name: 'user',
        type: 'AssetsUserDetails',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: true,
        readable: true,
        writeable: false,
        relationship: true,
        relationshipType: RelationshipType.ManyToOne,
        get relationshipEntityMetadata(): EntityMetadata {
          return ASSETS_USER_DETAILS_METADATA;
        },
        byReference: true,
        unique: false
      },
      assignmentType: <PropertyMetadata> {
        name: 'assignmentType',
        type: 'FirearmAssignmentType',
        plural: false,
        isIdentity: false,
        derived: false,
        required: true,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      },
      assignmentValid: <PropertyMetadata> {
        name: 'assignmentValid',
        type: 'boolean',
        plural: false,
        isIdentity: false,
        derived: false,
        required: true,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      },
      email: <PropertyMetadata> {
        name: 'email',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: true,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 255,
        unique: false
      },
      name: <PropertyMetadata> {
        name: 'name',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: true,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 255,
        unique: false
      },
      personType: <PropertyMetadata> {
        name: 'personType',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: true,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 255,
        unique: false
      },
      sourceKey: <PropertyMetadata> {
        name: 'sourceKey',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: true,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 255,
        unique: false
      },
      sourceType: <PropertyMetadata> {
        name: 'sourceType',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: true,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 255,
        unique: false
      }
    });
  }
  toKeyObject(item: any): any {
    const result = item?.personId;
    return nullIfContainsNull(result);
  }
}



